export { default } from './alternate-part-card';
